import { render } from "./wallet-list-page.vue?vue&type=template&id=e1efb7fa&scoped=true"
import script from "./wallet-list-page.vue?vue&type=script&lang=js"
export * from "./wallet-list-page.vue?vue&type=script&lang=js"

import "./wallet-list-page.vue?vue&type=style&index=0&id=e1efb7fa&scoped=true&lang=css"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1efb7fa"]])

export default __exports__